import * as React from 'react';
import { FC } from 'react';

import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { useLoyaltyContext } from 'state/loyalty';
import { DIFFERENCE_TIME_UNITS, getDifferenceToNow } from 'utils/dateTime';
import { routes } from 'utils/routing';

import { CooldownWrapper, StyledIcon, TextWrapper } from './loyalty-offers-cooldown.styled';

const LoyaltyOffersCooldown: FC = () => {
  const { loyaltyOffersInCooldown, loyaltyUser } = useLoyaltyContext();
  const { formatMessage } = useIntl();
  const { pathname } = useLocation();

  const isOffersPage = pathname.includes(routes.offers);
  const showCooldown = loyaltyOffersInCooldown && isOffersPage;

  const diffInMin = getDifferenceToNow(
    DIFFERENCE_TIME_UNITS.MINUTES,
    loyaltyUser?.offerRedemptionAvailableAfter || ''
  );

  return showCooldown ? (
    <CooldownWrapper>
      <StyledIcon />
      <TextWrapper>
        <b>{formatMessage({ id: 'offersCooldownTitle' })}</b>
        <p>
          {formatMessage(
            { id: 'offersCooldownDescription' },
            {
              minutes: diffInMin,
            }
          )}
        </p>
      </TextWrapper>
    </CooldownWrapper>
  ) : null;
};

export default LoyaltyOffersCooldown;
